import { useMutation, useQuery, useQueryClient } from "react-query";
import { createCustomField, deleteCustomField, fetchCustomFields, updateCustomField, } from "@/features/customField/services/customFieldService";
const useCustomFields = (activeOnly) => {
    const queryClient = useQueryClient();
    const queryKey = ["custom-fields", { activeOnly }];
    const { data, error, isLoading, refetch } = useQuery(queryKey, () => fetchCustomFields(activeOnly), {
        staleTime: 5 * 60 * 1000,
    });
    const createMutation = useMutation((payload) => createCustomField(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries("custom-fields");
        },
    });
    const updateMutation = useMutation(({ id, payload }) => updateCustomField(id, payload), {
        onSuccess: () => {
            queryClient.invalidateQueries("custom-fields");
        },
    });
    const deleteMutation = useMutation((id) => deleteCustomField(id), {
        onSuccess: () => {
            queryClient.invalidateQueries("custom-fields");
        },
    });
    return {
        fields: data ?? [],
        loading: isLoading,
        error: error?.message ?? null,
        refetchFields: refetch,
        createField: createMutation.mutateAsync,
        updateField: (field) => {
            if (!field.id) {
                throw new Error("Identifiant du champ manquant pour la mise à jour.");
            }
            const payload = {
                label: field.label,
                description: field.description,
                is_required: field.is_required,
                is_active: field.is_active,
                options: field.type === "select" ? field.options : undefined,
            };
            return updateMutation.mutateAsync({ id: field.id, payload });
        },
        createFieldWithFormValues: (field) => {
            const payload = {
                entity: field.entity,
                code: field.code,
                label: field.label,
                description: field.description,
                type: field.type,
                is_required: field.is_required,
                is_active: field.is_active,
                options: field.type === "select" ? field.options : undefined,
            };
            return createMutation.mutateAsync(payload);
        },
        deleteField: deleteMutation.mutateAsync,
    };
};
export default useCustomFields;
